import { render, staticRenderFns } from "./DocumentList.vue?vue&type=template&id=740f3276&scoped=true&lang=pug&"
import script from "./DocumentList.vue?vue&type=script&lang=js&"
export * from "./DocumentList.vue?vue&type=script&lang=js&"
import style0 from "./DocumentList.vue?vue&type=style&index=0&id=740f3276&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740f3276",
  null
  
)

export default component.exports